function imageToBase64(url: string): Promise<string | ArrayBuffer> {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        if (reader.result) {
          resolve(reader.result);
        } else {
          reject();
        }
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.onerror = reject;
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });
}

export default imageToBase64;
